export default {
  kpiAttrList: [], //* KPI 속성 리스트
  kpiAttrInfo: {}, //* KPI 속성 DETAIL 가져오기
  kpiAttrCheckInfo: {}, //* KPI 속성명 중복체크
  srchParam: {}, //* KPI속성 검색 PARAM
};
